import React from "react";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

// Shown on every surface where one person's trades are visible to another. Kept as
// a single component so the wording can never drift between pages.
export default function Disclaimer({ className = "" }) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="risk-disclaimer"
      className={`flex gap-2.5 rounded-xl border border-slate-100 bg-slate-50/70 p-3.5 text-[11px] leading-relaxed text-slate-500 ${className}`}
    >
      <Info size={14} className="shrink-0 mt-0.5 text-slate-400" />
      <p>{t("legal.notAdvice")}</p>
    </div>
  );
}
